import { AxiosRequestConfig } from 'axios';
import {
  AddCentsToSplitBookingsRequestData,
  DeleteSplitBookingsRequestData,
  GetLookupByColumnNameRequestData,
  IncomingInvoiceCreditorSearchProps,
  SendComplainRequestData,
  SplitBookingsFilterRequestData,
  SplitBookingsListRequestData
} from './incoming-invoce.props';
import { AnyObject } from 'common/interfaces';
import type { IncomingInvoiceType } from '@/entities/incoming-invoice';

export class IncomingInvoiceConfig {
  getPrefillOptions = (
    eingangsrechnungId: string,
    incidentNumber: string,
    uds_invoice_typecode?: IncomingInvoiceType
  ): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/GetPrefillOptions',
    data: { incidentNumber, uds_invoice_typecode, eingangsrechnungId }
  });

  searchCreditor = (data: IncomingInvoiceCreditorSearchProps): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/SearchKreditor',
    data
  });

  getLedgerAccountMapping = (accountId: string): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/GetSachkontoMapping',
    data: { accountId }
  });

  getIncomingInvoices = (incomingInvoiceId: string): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/getEingangsrechnungById',
    data: { eingangsrechnungId: incomingInvoiceId }
  });

  getSplitBookingsList = (data: SplitBookingsListRequestData): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/getSplitbuchungList',
    data
  });

  getSplitBookingsFilterData = (data: SplitBookingsFilterRequestData): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/getSplitbuchungFilterData',
    data
  });

  getSupplierCompanies = (): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/getLieferant',
    data: {}
  });

  getInvoiceMailboxAddress = (): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/GetInvoiceMailboxAddress',
    data: {}
  });

  sendComplaint = (dataToSend: SendComplainRequestData): AxiosRequestConfig => {
    const data = new FormData();
    dataToSend.files.forEach(file => {
      data.append('files', file);
    });
    data.append('eingangsrechnungId', dataToSend.eingangsrechnungId);
    data.append('kreditorEmail', dataToSend.kreditorEmail);
    data.append('nachricht', dataToSend.nachricht);
    data.append('antwortadresse', dataToSend.antwortadresse);
    data.append('subject', dataToSend.subject);

    return {
      method: 'post',
      url: 'eingangsrechnung/sendComplaint',
      data
    };
  };

  updateIncomingInvoice = (data: AnyObject): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/UpdateEingangsrechnung',
    data
  });

  getLookupByColumnName = (data: GetLookupByColumnNameRequestData): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/GetLookupByColumnName',
    data: {
      pagination: {
        number: 5000,
        start: 1
      },
      search: data
    }
  });

  updateSplitBookings = (items: AnyObject[]): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/UpdateSplitbuchung',
    data: {
      items
    }
  });

  createSplitBooking = (items: AnyObject[]): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/CreateSplitbuchung',
    data: {
      items
    }
  });

  deleteSplitBookings = (data: DeleteSplitBookingsRequestData): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/DeleteSplitbuchung',
    data
  });

  addCentsToSplitBookings = (data: AddCentsToSplitBookingsRequestData): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/AddCentsToSplitbuchungen',
    data
  });

  getInactiveCarsFromSplitBookings = (incomingInvoiceId: string): AxiosRequestConfig => ({
    method: 'post',
    url: 'eingangsrechnung/GetInactiveCarsFromSplitbuchungen',
    data: { eingangsrechnungId: incomingInvoiceId }
  });
}

export const incomingInvoiceConfig = new IncomingInvoiceConfig();
